export function createInstagramFeed() {
    if ($('.custom-footer__instagram').length) {
        const template = /* HTML */ `
            <div class="ig">
                <div class="container">
                    <div class="instagram-wrap"></div>
                </div>
            </div>
        `

        $(template).insertBefore('#footer')

        if ($('.instagram-widget > a').length) {
            $('.instagram-widget > a').each(function () {
                const href = $(this).attr('href')
                const imgSrc = $(this).find('img').attr('data-src')
                $('.instagram-wrap').append(/* HTML */ `
                    <div class="igfeed">
                        <a href="${href}" target="_blank" style="background-image: url(${imgSrc})"></a>
                    </div>
                `)
            })
        }
    }
}
